"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BrandOfferEditor_1 = require("./component/BrandOfferEditor");
var BrandsOffersList_1 = require("./component/BrandsOffersList");
var BrandsOffersOperationsConfig_1 = require("./component/BrandsOffersOperationsConfig");
var PBrandsOffersList = /** @class */ (function (_super) {
    __extends(PBrandsOffersList, _super);
    function PBrandsOffersList(props) {
        return _super.call(this, props) || this;
    }
    PBrandsOffersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AO = this.props.availOfferTypesList.Subscribe("*", function (id, data) {
            _this.setState({ avail_offers: data.data });
        });
        this.SID_AL = this.props.availLanguageList.Subscribe("*", function (id, data) {
            _this.setState({ avail_language: data.data });
        });
        this.SID_AB = this.props.availBrandsList.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.availCurrencyList.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            recordRoot: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_offers: [],
            avail_language: [],
            avail_brands: [],
            avail_currency: []
        }, function () {
            _this.props.availOfferTypesList.LoadData();
            _this.props.availLanguageList.LoadData();
            _this.props.availCurrencyList.LoadData();
            _this.props.availBrandsList.LoadData();
        });
    };
    PBrandsOffersList.prototype.componentWillUnmount = function () {
        this.props.availOfferTypesList.UnSubscribe(this.SID_AO);
        this.props.availLanguageList.UnSubscribe(this.SID_AL);
        this.props.availCurrencyList.UnSubscribe(this.SID_AC);
        this.props.availBrandsList.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PBrandsOffersList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", recordRoot: null });
    };
    PBrandsOffersList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", recordRoot: val });
    };
    PBrandsOffersList.prototype.onGoBackToRootClick = function () {
        this.setState({ edit_mode: "LIST", recordRoot: null });
    };
    PBrandsOffersList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PBrandsOffersList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PBrandsOffersList.prototype.onOperationsConfigClick = function (val) {
        this.setState({ edit_mode: "OPERATIONS-CONFIG", recordRoot: val });
    };
    PBrandsOffersList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BrandOfferEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackToRootClick.bind(this), offerTypesAvail: this.state.avail_offers, brandsAvail: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BrandOfferEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.recordRoot, onGoBack: this.onGoBackToRootClick.bind(this), offerTypesAvail: this.state.avail_offers, brandsAvail: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BrandsOffersList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onOperationsConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "OPERATIONS-CONFIG") {
            return (React.createElement(BrandsOffersOperationsConfig_1.default, { dataOffersCountries: this.props.dataOffersCountries, state: this.props.state, record: this.state.recordRoot, onGoBackClick: this.onGoBackToRootClick.bind(this), listAvailAppCountries: this.props.availCountryList, listAvailAppLanguages: this.props.availLanguageList, dataOffersLocales: this.props.dataLocale }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PBrandsOffersList.prototype.render = function () {
        return this.getRenderObject();
    };
    PBrandsOffersList.getPageDescription = function (state) {
        return {
            icon: "percent",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_brands_offers + "-id",
            itemTitle: "Офферы",
            route: routes_1.routes.page_par_brands_offers,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PBrandsOffersList;
}(React.Component));
exports.default = PBrandsOffersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ui/PBrandsOffersList.tsx
// module id = 2422
// module chunks = 0